<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="dialogTitle"
      class="ipqc-template-edit"
      width="1000px"
      top="8vh"
      @close="$reset('form')">
    <el-form ref="form" :model="templateVo" :rules="ruleValidate" class="form" label-width="110px">
      <div class="vm-separate">
        <el-form-item label="模板编码" prop="templateCode">
          <el-input v-model.trim="templateVo.templateCode" placeholder="请输入模板编码" :disabled="readonly" clearable/>
        </el-form-item>
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model.trim="templateVo.templateName" placeholder="请输入模板名称" :disabled="readonly" clearable/>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="templateVo.isEnabled" :disabled="readonly">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="时段配置" prop="periodText">
        <el-input
            v-model.trim="templateVo.periodText"
            type="textarea"
            :rows="2"
            :disabled="readonly"
            placeholder="固定5个时段,用竖线|分隔。示例: 08:30-10:00|10:00-12:00|13:00-15:00|15:00-17:30|18:00-20:00"/>
      </el-form-item>
      <div>
        <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 10px">
          检验明细
        </div>
        <el-button v-if="!readonly" type="primary" style="margin-bottom: 10px" @click="addDetail">新增明细</el-button>
        <el-table :data="templateVo.detailList" border>
          <el-table-column type="index" align="center" width="55" label="序号"/>
          <el-table-column prop="station" align="center" label="工位" width="180">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.station" placeholder="请输入工位" :disabled="readonly"/>
            </template>
          </el-table-column>
          <el-table-column prop="checkItem" align="center" label="检查项目">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.checkItem" type="textarea" :rows="1" placeholder="请输入检查项目" :disabled="readonly"/>
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" align="center" width="90" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">{{readonly ? '关闭' : '取消'}}</el-button>
      <el-button v-if="!readonly" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "IpqcTemplateEdit",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        readonly: false,
        templateVo: {
          pkid: 0,
          templateCode: "",
          templateName: "",
          periodText: "",
          isEnabled: 1,
          detailList: [],
        },
        ruleValidate: {
          templateCode: { required: true, message: "模板编码不能为空", trigger: "blur" },
          templateName: { required: true, message: "模板名称不能为空", trigger: "blur" },
          periodText: {
            validator: (rule, value, callback) => {
              const parts = value ? value.split("|") : [];
              if (parts.length !== 5) {
                callback(new Error("必须配置5个时段,用|分隔"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        },
      };
    },
    computed: {
      dialogTitle() {
        if (this.readonly) return "模板预览";
        return this.templateVo.pkid > 0 ? "编辑模板" : "新建模板";
      },
    },
    methods: {
      open(row, readonly) {
        this.readonly = !!readonly;
        this.dialogVisible = true;
        this.templateVo = {
          pkid: 0,
          templateCode: "",
          templateName: "",
          periodText: "08:30-10:00|10:00-12:00|13:00-15:00|15:00-17:30|18:00-20:00",
          isEnabled: 1,
          detailList: [],
        };
        if (row && row.pkid) {
          this.templateVo.pkid = row.pkid;
          this.getData();
        }
      },
      getData() {
        this.$http.get("basic", `ipqcChecks/${this.templateVo.pkid}`).then((resp) => {
          if (resp.success) {
            this.templateVo = resp.data;
            if (!this.templateVo.detailList) {
              this.templateVo.detailList = [];
            }
          }
        });
      },
      addDetail() {
        this.templateVo.detailList.push({ station: "", checkItem: "" });
      },
      oneDelete(index) {
        this.templateVo.detailList.splice(index, 1);
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http.post("basic", "ipqcChecks/template/save", this.templateVo).then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
            }).catch(() => {
              this.submitLoading = false;
            });
          }
        });
      },
    },
  };
</script>
